<template>
  <div id="order-new__resume">
    <ul class="order-new__list">
      <li v-if="!isCoagraWeb">Sub total: <currency :value="subTotal"/></li>
      <li>Despacho: <currency :value="serviceFreightValue"/></li>
      <li>Entrega urgente: <currency :value="serviceDateValue"/></li>
      <li v-if="sackServiceValue > 0">
        Servicios adicionales: <currency :value="sackServiceValue"/>
      </li>
      <li>Servicio de venta: <currency :value="salesService"/></li>
      <li>Total neto: <currency :value="netTotal"/></li>
      <li>IVA: <currency :value="iva"/></li>
      <li><span class="order-new__list-label">Monto total</span><currency :value="totalPrice"/></li>
    </ul>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import currency from '../../tools/currency';

export default {
  components: {
    currency,
  },
  computed: {
    ...mapGetters([
      'subTotal',
      'serviceDateValue',
      'serviceFreightValue',
      'sackServiceValue',
      'salesService',
      'netTotal',
      'iva',
      'totalPrice',
    ]),
    isCoagraWeb() {
      return this.$store.state.order.isCoagraWeb;
    },
  },
};
</script>
